import { TEMPLATE_KEY_BY_ENTITY, type WhereDataset } from '@parcel/filters';
import * as React from 'react';
import { tierOptions } from '../components/where-bar/tier-shortcuts.js';
import type { WhereOptions } from '../components/where-bar/where-menu.js';
import { useWorkspaceFilterOptions } from './filter-options.js';
import { useScore } from './scores.js';
import { useWorkspaceViews } from './workspace-views.js';

/** The value lists a table's where bar needs, from the API and the workspace's Views and score tiers. */
export function useWhereOptions(
  workspaceId: string | undefined,
  dataset: WhereDataset,
): WhereOptions {
  const filterOptions = useWorkspaceFilterOptions(workspaceId, dataset).data;
  const views = useWorkspaceViews(workspaceId, dataset).data;
  const score = useScore(workspaceId, TEMPLATE_KEY_BY_ENTITY[dataset]).data;
  return React.useMemo(
    () => ({
      cities: filterOptions?.cities ?? [],
      firm_cities: filterOptions?.firm_cities ?? [],
      neighborhoods: filterOptions?.neighborhoods ?? [],
      tags: filterOptions?.tags ?? [],
      statuses: filterOptions?.statuses ?? [],
      views: (views ?? []).map((view) => ({ value: view.id, label: view.name })),
      tiers: score ? tierOptions(score.buckets) : [],
    }),
    [filterOptions, views, score],
  );
}
